/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */

import { constants as L100Constants } from '../../constants'
import $ from 'jquery'
// eslint-disable-next-line lodash-fp/consistent-name, lodash-fp/use-fp
import { map, cloneDeep, find } from 'lodash'
import React, { Component, Fragment } from 'react'
import ReactHtmlParser from 'html-react-parser'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import { bindActionCreators } from 'redux'
import { VISIT_URL } from '../../api/endpoints'
import BlueCheckmark from '../../assets/icons/blue_checkmark.svg'
import ExpandIcon from '../../assets/icons/expand.svg'
import LogoBlack from '../../assets/icons/logo-black.svg'
import SurveyThankYouIcon from '../../assets/icons/survey_thankyou.svg'
import Button from '../../components/Button'
import CircularScale from '../../components/CircularScale'
import List from '../../components/List'
import Spinner from '../../components/Spinner'
import { helpfulTools } from '../../config/app'
import * as actionCreators from '../../root/actions'
import style from './style'

export class UpcomingVisit extends Component {
  state = {
    isVisitReady: false,
    isUserReady: false,
    visitFeedback: null,
    activeHelpfulItem: null,
    showHelpfulModal: false,
    submittingFeedback: false,
    doneSubmittingFeedback: false,
    feedbackRating: null,
    feedbackText: '',
    feedbackVisitId: null,
    showFeedbackModal: false,
    isNotSubmittedFeedback: true,
    submittingStatement: 'Thank you for your feedback!'
  }

  renderNoVisit() {
    const { containers } = this.props
    const { app } = containers
    const isMobile = app.get('isMobile')
    const ButtonText = 'Schedule Appointment'

    return (
      <Fragment>
        <h3 style={{ marginBottom: '45px' }}>
          You have no scheduled appointments at this time.
        </h3>
        <br />
        <Fragment>
          <Button
            scheme={!isMobile ? 'light' : 'dark'}
            onClick={() =>
              this.props.changeRoute({ route: '/upcoming/schedule' })
            }
          >
            {ButtonText}
          </Button>
          <br />
          <br />
        </Fragment>
        {!isMobile && (
          <Fragment>
            <br />
            <br />
            <br />
            <br />
          </Fragment>
        )}
        <h3 style={{ maxWidth: '300px' }}>
          Here’s some helpful info about what to expect from your visit.
        </h3>
      </Fragment>
    )
  }

  renderHasVisit() {
    const { classes, containers, changeRoute } = this.props
    const { app } = containers
    const { longFormattedDate } = app.get('upcomingVisit')
    const isMobile = app.get('isMobile')
    const upcomingVisit = app.get('upcomingVisit')
    const ButtonText =
      upcomingVisit !== null ? 'Change Appointment' : 'Schedule Appointment'

    return (
      <Fragment>
        <h3 style={{ marginBottom: '0 !important' }}>
          {!app.get('isMobile')
            ? 'You have an appointment scheduled for:'
            : 'Your visit is scheduled for:'}
        </h3>
        {!isMobile && (
          <Fragment>
            <br />
            <br />
          </Fragment>
        )}
        <h1 className={classes.upcomingVisit}>
          <span>{longFormattedDate}</span>{' '}
          {!isMobile ? (
            <Button
              style={{ alignSelf: 'center' }}
              scheme="light"
              onClick={() => changeRoute({ route: '/upcoming/schedule' })}
            >
              {ButtonText}
            </Button>
          ) : null}
        </h1>
        {isMobile && (
          <Fragment>
            <Button
              scheme="dark"
              onClick={() => changeRoute({ route: '/upcoming/schedule' })}
            >
              {ButtonText}
            </Button>
            {upcomingVisit !== null && (
              <Button
                scheme="light"
                style={{ marginTop: '15px' }}
                onClick={() => {
                  this.props.cancelFromUpcomingVisit(true)
                  changeRoute({ route: '/upcoming/schedule' })
                }}
              >
                Cancel Appointment
              </Button>
            )}
          </Fragment>
        )}
        {!isMobile && (
          <Fragment>
            <br />
            <br />
            <br />
            <br />
          </Fragment>
        )}
        <h3>
          {/* theme.font.sizes.small.... im getting lazy in the rush */}
          For now, while you wait, here are some helpful tools to help you
          prepare for your visit.
        </h3>
      </Fragment>
    )
  }

  calculateSurveyProgress(activeAssessments) {
    let assessmentProgress = 0
    for (const key in activeAssessments) {
      if (key !== 'consent') {
        if (activeAssessments[key].completed) ++assessmentProgress
      }
    }
    return assessmentProgress
  }

  // consent done? show helpful tools. else show Next button then goto Consent

  onCloseHelpfulModal = () => {
    this.setState({ showHelpfulModal: false }, () => $('.main-content').focus())
  }

  render() {
    const { classes, containers, changeRoute } = this.props
    const { app } = containers
    const isMobile = app.get('isMobile')
    const upcomingVisit = app.get('upcomingVisit')
    const activeAssessments = app.get('activeAssessments')
    const action = changeRoute
    const tools = cloneDeep(helpfulTools)

    map(tools, (value, key) => {
      if (isMobile) value.icon = { src: ExpandIcon }
      value.onClick = () => {
        this.setState({
          activeHelpfulItem: key,
          showHelpfulModal: true
        })
      }
    })

    const { assessments, directions, whatToExpect, whatToWear, contact } = tools

    const route =
      upcomingVisit && upcomingVisit.route
        ? `/visits/${upcomingVisit.uuid}/assessments`
        : ''

    assessments.route = route

    const items =
      upcomingVisit !== null
        ? [assessments, directions, whatToExpect, whatToWear, contact]
        : [whatToExpect, contact]

    if (upcomingVisit !== null && this.state.isVisitReady) {
      // got activeassessments

      const completedAssessments = this.calculateSurveyProgress(
        activeAssessments
      )
      let text = null
      let noMobilePadding = false

      if (app.get('isUpcomingVisitAssessmentsNotice')) {
        text = 'Update'
      } else if (completedAssessments === 8) {
        text = `${completedAssessments}/8${!app.get('isMobile') ? ' completed' : ''
          }<img src="${BlueCheckmark}"/>`
        noMobilePadding = app.get('isMobile')
      } else {
        text = `${completedAssessments}/8${!app.get('isMobile') ? ' completed' : ''
          }`
      }
      assessments.icon = {
        text,
        isPaddedIcon: app.get('isUpcomingVisitAssessmentsNotice'),
        noMobilePadding
      }
    }

    const listProps = {
      items,
      action,
      isMobile,
      isBoldOnMobile: true
    }

    return (
      <Fragment>
        {!this.state.isVisitReady || !this.state.isUserReady ? (
          <Spinner />
        ) : (
          <div className={`${classes.base} mobile-padding`}>
            {upcomingVisit !== null ? (
              <h2>Upcoming Visit</h2>
            ) : (
              <h2>Schedule a Visit</h2>
            )}
            <div className="flexRowSpaceBetween">
              <div className="leftCol">
                {upcomingVisit !== null
                  ? this.renderHasVisit()
                  : this.renderNoVisit()}
              </div>
            </div>
            <Fragment>
              <List {...listProps} />
              <br />
              <br />
              <br />
            </Fragment>
            {this.renderFeedbackModal()}
            {isMobile && this.renderHelpfulModal()}
          </div>
        )}
      </Fragment>
    )
  }

  componentDidMount() {
    this.setState({ isVisitReady: false })
    this.props.highlightNavbarSection('upcomingVisit')
    const { app } = this.props.containers
    const upcomingVisit = app.get('upcomingVisit')
    this.props.checkIfMobile() // when completing visit on dev state resets to false, ask to check again

    const visitWithoutFeedback = find(app.get('user').visits, {
      status: { hasFeedback: false, completed: true }
    })

    if (visitWithoutFeedback !== undefined) {
      this.setState({
        showFeedbackModal: true,
        feedbackVisitId: visitWithoutFeedback.uuid
      })
    }

    if (upcomingVisit) {
      this.props.getActiveAssessments(
        {},
        {
          visitId: upcomingVisit.uuid,
          onSuccess: () => this.setState({ isVisitReady: true })
        }
      )
    } else this.setState({ isVisitReady: true })
  }

  renderHelpfulModal() {
    return (
      <Modal
        classNames={{
          modal: 'feedback-modal',
          overlay: 'feedback-overlay',
          closeButton: 'modal-close-btn'
        }}
        open={this.state.showHelpfulModal}
        center
        showCloseIcon
        animationDuration={100}
        onClose={this.onCloseHelpfulModal}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        closeIconSvgPath={
          <path
            strokeLinecap="round"
            stroke="black"
            strokeWidth="2"
            d="M 10,10 L 30,30 M 30,10 L 10,30"
          />
        }
      >
        <div className="mobile-padding">
          <img src={LogoBlack} className="modal-logo" alt="header" />
          <h2 style={{ fontWeight: 500 }}>
            {this.state.showHelpfulModal &&
              helpfulTools[this.state.activeHelpfulItem].title}
          </h2>
          {this.state.showHelpfulModal &&
            ReactHtmlParser(
              helpfulTools[this.state.activeHelpfulItem].accordianContent
            )}
        </div>
      </Modal>
    )
  }

  onCloseFeedbackModal = () => {
    if (this.state.isNotSubmittedFeedback) this.submitFeedback()
  }

  submitFeedback = (e, canceled) => {
    if (e) e.preventDefault()

    const {
      apiRequest,
      containers,
      getUserFromDBAndUpdateStore,
      changeRoute,
      highlightNavbarSection
    } = this.props
    const { nav } = containers
    const visitId = this.state.feedbackVisitId
    this.setState({ isNotSubmittedFeedback: false })

    let notes = this.state.feedbackText
    let rating = this.state.feedbackRating

    let feedback = {}

    if (rating === null || canceled) {
      rating = L100Constants.other
      feedback = { rating }
      this.setState({
        submittingFeedback: true,
        submittingStatement: 'Thank you for visiting Lab100!'
      })
    } else {
      feedback = { notes, rating }
      this.setState({
        submittingFeedback: true,
        submittingStatement: 'Thank you for your feedback!'
      })
    }

    const request = {
      url: `${VISIT_URL}/${visitId}/feedback`, // hardcode url for now
      data: feedback,
      method: 'put'
    }

    const onSuccess = () => {
      this.setState({ doneSubmittingFeedback: true })
      getUserFromDBAndUpdateStore({
        onSuccess: () => {
          setTimeout(() => {
            this.setState({
              showFeedbackModal: false
            })
            const route = nav.get('sortedNav').currentReport.route
            highlightNavbarSection('currentReport')
            changeRoute({ route })
          }, 2000)
        }
      })
    }

    const meta = {
      onSuccess,
      onError: onSuccess
    }

    apiRequest(request, meta)
  }

  changeFeedbackRating = ({ score }) => {
    this.setState({
      feedbackRating: score
    })
  }

  renderFeedbackModal() {
    const { app } = this.props.containers

    return (
      <Modal
        classNames={{
          modal: 'feedback-modal',
          overlay: 'feedback-overlay',
          closeButton: 'modal-close-btn'
        }}
        open={this.state.showFeedbackModal}
        onClose={this.onCloseFeedbackModal}
        little
        center
        showCloseIcon={
          app.get('isMobile') &&
          this.state.isNotSubmittedFeedback &&
          !this.state.submittingFeedback
        }
        animationDuration={100}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        {app.get('isMobile') && (
          <div className="mobile-padding">
            <img src={LogoBlack} className="modal-logo" alt="header" />
          </div>
        )}

        {this.state.submittingFeedback ? (
          <div
            className="loaderHolder"
            style={{ height: 'calc(100% - 140px)' }}
          >
            {this.state.doneSubmittingFeedback ? (
              <div className="feedback-thanks-container">
                {app.get('isMobile') && (
                  <img
                    className="feedback-checkmark"
                    src={SurveyThankYouIcon}
                    alt="feedback-checkmark"
                  />
                )}

                <h1 className="feedback-thanks">
                  {this.state.submittingStatement}
                </h1>
              </div>
            ) : (
              <Spinner />
            )}
          </div>
        ) : (
          <form>
            <div className="feedback-ratings-container">
              {app.get('isMobile') && <br />}
              <CircularScale
                onSubmit={this.changeFeedbackRating}
                service="Lab100"
              />
            </div>
            <div className="mobile-padding feedback-text-container feedback-text-container-margin-top">
              <div className="feedback-notes-label">Tell us why:</div>
              <textarea
                className="feedback-text"
                value={this.state.feedbackText}
                onFocus={() => null}
                onBlur={() => null}
                onChange={e => {
                  this.setState({ feedbackText: e.target.value })
                }}
              />
            </div>

            <Button
              type="submit"
              scheme="light"
              onClick={e => this.submitFeedback(e, true)}
              className="btn feedback-cancel"
            >
              No, thanks
            </Button>
            <Button
              type="submit"
              fullWidth={app.get('isMobile')}
              fixed
              onClick={this.submitFeedback}
              className="btn feedback-submit"
            >
              Submit
            </Button>
          </form>
        )}
      </Modal>
    )
  }

  UNSAFE_componentWillMount() {
    const { getUserFromDBAndUpdateStore } = this.props

    const onSuccess = _user => {
      // const hasVisit = !!(user && user.visits && user.visits.length > 0)
      // if (!hasVisit) //changeRoute({ route: '/upcoming/schedule' })
      // else
      this.setState({ isUserReady: true })
    }
    const meta = { onSuccess }
    getUserFromDBAndUpdateStore(meta)
  }
}

const mapStateToProps = state => {
  const { containers, api } = state

  return {
    containers,
    api
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}
const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UpcomingVisit)
)
